/**
 * Tab memory (docs/ux/artboards/optimal decision 10): each tab — Home and every project — keeps
 * where you were (its view, inspector `?i=` and run) for this page session, so leaving a tab and
 * coming back with one key (⌥N, a tab click) lands on the same place. Pressing the tab you are
 * already in goes to its root. In memory only: nothing is stored or sent.
 */
import { projectOfPath } from './ia.js'

const places = new Map<string, string>()

/** `home`, a project id, or undefined for places outside the tabs (Settings, short run links). */
export function tabOfPath(pathname: string): string | undefined {
  if (pathname === '/home' || pathname.startsWith('/home/')) return 'home'
  return projectOfPath(pathname)
}

/** Records `pathname` + `search` as its tab's current place. */
export function rememberPlace(pathname: string, search: string) {
  if (!pathname.startsWith('/') || pathname.startsWith('//')) return
  const tab = tabOfPath(pathname)
  if (!tab) return
  const q = search && !search.startsWith('?') ? `?${search}` : search
  places.set(tab, `${pathname}${q}`)
}

/** Where `tab` reopens: its remembered place, or `root` when it has none or is `current`. */
export function placeOf(tab: string, root: string, current?: string): string {
  if (tab === current) return root
  return places.get(tab) ?? root
}

export function forgetPlaces() {
  places.clear()
}
